import { EasmScanConfigurationItemFormWebComponent } from './component/EasmScanConfigurationItemFormWebComponent';

export { EasmScanConfigurationItemFormWebComponent };
